import React from 'react';
import useGetDealerSettings from 'common/hooks/useGetDealerSettings';
import EnterNewPassword from './EnterNewPassword';
import EnterToken from './EnterToken';
import ChangePasswordSuccess from './ChangePasswordSuccess';
import InvalidSecret from './InvalidSecret';
import InvalidToken from './InvalidToken';
import RequestingToken from './RequestingToken';
import CustomerSupport from './CustomerSupport';
import InvalidPhoneNumber from './InvalidPhoneNumber';
import { ChangePasswordState, useChangePassword } from './useChangePassword';

const ChangePassword = () => {
  const {
    isLoading,
    phone,
    state,
    error,
    resetError,
    requestSmsToken,
    validateSmsToken,
    changePassword,
  } = useChangePassword();

  const {
    dealerSettings: { phone: supportPhoneNumber },
  } = useGetDealerSettings();

  switch (state) {
    case ChangePasswordState.REQUESTING_TOKEN:
      return <RequestingToken />;
    case ChangePasswordState.TOKEN_REQUESTED:
      return (
        <EnterToken
          validateSmsToken={validateSmsToken}
          isLoading={isLoading}
          error={error}
          resetError={resetError}
          phone={phone}
        />
      );
    case ChangePasswordState.TOKEN_VALIDATED:
      return <EnterNewPassword changePassword={changePassword} isLoading={isLoading} error={error} />;
    case ChangePasswordState.PASSWORD_UPDATED:
      return <ChangePasswordSuccess />;
    case ChangePasswordState.INVALID_TOKEN:
      return <InvalidToken requestSmsToken={requestSmsToken} isLoading={isLoading} error={error} />;
    case ChangePasswordState.INVALID_PHONE:
      return <InvalidPhoneNumber supportPhoneNumber={supportPhoneNumber} />;
    case ChangePasswordState.UNKNOWN_ERROR:
      return (
        <CustomerSupport
          supportPhoneNumber={supportPhoneNumber}
          requestSmsToken={requestSmsToken}
          isLoading={isLoading}
          error={error}
        />
      );
    case ChangePasswordState.INVALID_SECRET:
    default:
      return <InvalidSecret />;
  }
};

export default ChangePassword;
